import { useState } from "react";
import { Spinner } from "@repo/ui/components/Base/Spinner";
import { DataTable } from "@repo/ui/components/Base/DataTable";
import { layoutDefaults, useColumns } from "./TeamMembersDataTableColumns";
import { EditTeamMemberSheet } from "./EditTeamMemberSheet";
import { DeleteConfirmation } from "./DeleteConfirmation";
import { useUserColumns } from "@/hooks/useUserColumns";
import { KEYS } from "@/lib/constants";
import { useGetTeam } from "@/hooks/queryHooks/teamHooks";
import { teamRepo } from "@/repositories/teamRepo";

export const TeamMembersTable = ({
  tenantId,
  teamId,
}: {
  tenantId: string;
  teamId: string;
}) => {
  const { data: team } = useGetTeam(tenantId, teamId);

  const [activeId, setActiveId] = useState<string>();
  const [editSheetOpen, setEditSheetOpen] = useState(false);
  const [confirmRemoveOpen, setConfirmRemoveOpen] = useState(false);

  const { defaultState, saveTableLayout, resetTableLayout } = useUserColumns(
    KEYS.TEAMMEMBER_TABLE_COLUMNS,
    layoutDefaults
  );

  const handleQuickEdit = (id: string) => {
    setActiveId(id);
    setEditSheetOpen(true);
  };

  const handleDelete = (id: string) => {
    setActiveId(id);
    setConfirmRemoveOpen(true);
  };

  const confirmDelete = async () => {
    if (activeId) {
      await teamRepo.removeMember(tenantId, teamId, activeId);
    }
  };

  return (
    <>
      <DeleteConfirmation
        onConfirm={() => confirmDelete()}
        open={confirmRemoveOpen}
        setOpen={setConfirmRemoveOpen}
      />
      {!team && <Spinner />}
      {activeId && (
        <EditTeamMemberSheet
          open={editSheetOpen}
          setOpen={setEditSheetOpen}
          tenantId={tenantId}
          teamId={teamId}
          userId={activeId}
        />
      )}

      <DataTable
        columns={useColumns({
          handleQuickEdit,
          handleDelete,
        })}
        data={team?.teamMembers ?? []}
        filterColumn={{ label: "title", columnName: "title" }}
        userDefaults={defaultState}
        factoryDefaults={layoutDefaults}
        onLayoutSave={saveTableLayout}
        onLayoutReset={resetTableLayout}
        fixedHeader={false}
      />
    </>
  );
};
